import { useTranslation } from 'react-i18next';
import { StatusBadge, type StatusBadgeStatus } from '@xxtract/ui';
import type { OrderServiceAggregate } from '../orders.api';

/**
 * fu-6/AC4: the mockup's "AANMELDING 8/12"-style voortgangs-badge — replaces the plain grey
 * "stap X van Y" text. Color is never the only signal: label + icon always make the state
 * explicit (NFR9/UX-DR1). Missing procesdata (progress: null) always renders as the dashed
 * "geen procesdata" badge, regardless of the underlying service state (mirrors the mockup row
 * where an `active` service without progress data still shows the neutral no-data badge).
 */
export function OrdersProgressBadge({ service }: { service: OrderServiceAggregate }) {
  const { t } = useTranslation();

  if (service.progress == null) {
    return <StatusBadge status="process-no-data" label={t('orders.table.noProcessData')} />;
  }

  const statusByState: Record<OrderServiceAggregate['state'], StatusBadgeStatus> = {
    completed: 'process-complete',
    active: 'process-current',
    onhold: 'process-on-hold',
    canceled: 'process-no-data',
  };

  const label = service.state === 'canceled'
    ? `${service.serviceCode} — ${t('orders.state.canceled')}`
    : t('orders.table.progressBadge', {
      serviceCode: service.serviceCode,
      current: service.progress.currentStepNumber ?? 0,
      total: service.progress.totalSteps,
    });

  return <StatusBadge status={statusByState[service.state]} label={label} />;
}
